<template>
  <SVGIcon
    class="text-core-primary-30"
    :class="{'pointer': !disabled}"
    :iconName="stateIcon"
    :colorClass="color"
    @click="updateValue" />
</template>

<script setup lang="ts">
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { CheckboxState } from 'frontcore/views/selection-control/types'
import { computed } from 'vue'

interface Props {
  disabled?: boolean
  value: CheckboxState
}

const props = withDefaults(defineProps<Props>(),{
  disabled: false,
})

type Emits = (e: 'input:value', value: Props['value']) => void

const emit = defineEmits<Emits>()

const stateIcon = computed(() => {
  switch (props.value) {
  case CheckboxState.UNCHECKED:
    return 'CheckboxUnchecked'
  case CheckboxState.CHECKED:
    return 'CheckboxCheckedFill'
  case CheckboxState.INDETERMINATE:
    return 'CheckboxIndeterminate'
  }
  return 'CheckboxIndeterminate'
})

const color = computed(() => props.disabled ? 'tw-fill-core-neutral-cold-80' : 'tw-fill-core-primary-10')

const updateValue = () => {
  if (props.disabled) return
  let newValue = CheckboxState.UNCHECKED
  switch (props.value) {
  case CheckboxState.UNCHECKED:
    newValue = CheckboxState.CHECKED
    break
  case CheckboxState.CHECKED:
    newValue = CheckboxState.UNCHECKED
    break
  case CheckboxState.INDETERMINATE:
    newValue = CheckboxState.UNCHECKED
    break
  }
  emit('input:value', newValue)
}

</script>
